import { Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import SButton from './sbutton';
import { useToaster } from './toaster';
import { isMobile } from '../../src/util/ismobile';

type Props = {
  data: ShareData;
  title: string;
  text?: string;
  large?: boolean;
  small?: boolean;
  minimal?: boolean;
};

export default function ShareButton({ data, ...buttonProps }: Props) {
  const toaster = useToaster();

  const share = async () => {
    try {
      const url = new URL(data.url ?? window.location.href, window.location.origin).toString();
      if (isMobile() && navigator.share) {
        await navigator.share({ ...data, url });
      } else {
        await navigator.clipboard.writeText(url);
        toaster?.show({ message: 'Copied to clipboard.', intent: Intent.SUCCESS });
      }
    } catch (err) {
      if (err instanceof DOMException && err.name === 'AbortError') {
        return;
      }
      toaster?.show({ message: 'Error sharing.', intent: Intent.WARNING });
    }
  };

  return <SButton icon={IconNames.SHARE} aria-label={buttonProps.title} {...buttonProps} onClick={share} />;
}
